// Pure menu-visibility predicate (Phase 5). No import declarations on purpose:
// Node loads this file directly in the phase checks.
// The backend gate compares the profile label with strict equality, so this UX hint
// is strict too: no case folding, no trimming. It only hides an entry; the server decides.

export const isUserTypeAllowed = (allowed, userType) => (
  Array.isArray(allowed) && typeof userType === 'string' && allowed.includes(userType)
)

const isPlainObject = value => value !== null && typeof value === 'object' && !Array.isArray(value)

// Filters a navigation list by the profile of the current user, recursing into groups.
// An entry declaring `userTypes` survives only when the profile is listed (an empty or
// malformed declaration hides it: fail closed). A group survives only with at least one
// surviving child. Never mutates its input: groups are returned as shallow copies.
export const filterNavItemsByUserType = (items, userType) => {
  if (!Array.isArray(items)) return []

  return items.reduce((visible, entry) => {
    if (!isPlainObject(entry)) return visible
    if (entry.userTypes !== undefined && !isUserTypeAllowed(entry.userTypes, userType)) return visible

    if (Array.isArray(entry.children)) {
      const children = filterNavItemsByUserType(entry.children, userType)
      if (children.length === 0) return visible
      return [...visible, { ...entry, children }]
    }

    return [...visible, entry]
  }, [])
}

export default {
  isUserTypeAllowed,
  filterNavItemsByUserType,
}
